<template>
  <div class="item">
    <div class="pic-box">
      <img class="p1" src="../../../assets/img/safe-p1.png">
      <div class="p2"></div>
    </div>
    <h1>资产管理及安全服务</h1>
    <div class="con">
      <span>身份校验</span><span class="margin-l">资产自主管理</span><br>
      <span>签名认证</span><span class="margin-l">跨链技术支持</span>
    </div>
  </div>
</template>

<script>
    export default {
        name: "safe-service"
    }
</script>

<style lang="less" scoped>
  @import "../../../assets/less/animate";
  .item {
    width: 25%;
    height: 100%;
    min-width: 290px;
    cursor: pointer;
    .pic-box {
      position: relative;
      margin: 82px auto 0;
      width: 172px;
      height: 130px;
      .p1 {
        position: absolute;
        left: calc(~'50% - 67px');
      }
      .p2 {
        width: 42px;
        height: 42px;
        position: absolute;
        left: 55px;
        top: calc(~'50% - 21px');
        background: url("../../../assets/img/safe-p2.png");
      }
    }
    h1 {
      margin: 40px 0 25px;
      font-size: 2rem;
      text-align: center;
    }
    .con {
      font-size: 1.75rem;
      color: #999999;
      text-align: center;
      .margin-l {
        margin-left: 10px;
      }
    }
    &:hover {
      box-shadow:0px 0px 40px rgba(111,111,111,0.04);
    }
    &:hover .p2 {
      background: url("../../../assets/img/safe-p3.png");
      background-size: 100% 100%;
      animation: safe-p2 3s linear infinite;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/part2/pics/SafeService.vue